import { ConfigSelectOption } from 'store/types/SelectOption';
import ApplicationStatus from 'store/enums/ApplicationStatus';

interface ApplicationStatusConfig extends ConfigSelectOption {
  severity?: 'info' | 'warning' | 'error' | 'success';
}

const applicationStatusConfig: Record<ApplicationStatus, ApplicationStatusConfig> = {
  [ApplicationStatus.Draft]: {
    name: 'Draft',
    theme: 'grey',
    severity: 'warning',
  },
  [ApplicationStatus.PendingPayment]: {
    name: 'Pending Payment',
    theme: 'yellow',
    severity: 'warning',
  },
  [ApplicationStatus.InformationRequired]: {
    name: 'More Information Needed',
    theme: 'dark-yellow',
    severity: 'warning',
  },
  [ApplicationStatus.Submitted]: {
    name: 'Submitted',
    theme: 'blue',
    severity: 'info',
  },
  [ApplicationStatus.UnderReview]: {
    name: 'Under Review',
    theme: 'violet',
    severity: 'info',
  },
  [ApplicationStatus.Approved]: {
    name: 'Approved',
    theme: 'green',
    severity: 'success',
  },
  [ApplicationStatus.Denied]: {
    name: 'Denied',
    theme: 'red',
    severity: 'error',
  },
};

export default applicationStatusConfig;
